"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusServiceStatus = void 0;
const react_query_1 = require("react-query");
const useCirrus_1 = require("./useCirrus");
function useCirrusServiceStatus() {
    const { socket } = useCirrus_1.useCirrus();
    return react_query_1.useQuery(['cirrus-service-status', serializeSocket(socket)], () => __awaiter(this, void 0, void 0, function* () {
        return yield socket.request({ messageType: 'ServiceRequest' });
    }));
}
exports.useCirrusServiceStatus = useCirrusServiceStatus;
function serializeSocket(socket) {
    return `YanziSocket-${socket.id}`;
}
//# sourceMappingURL=useCirrusServiceStatus.js.map